import styled, { createGlobalStyle } from "styled-components";
import Button from "~/components/ui/Button";
import { getBorderRadius, getColor, getSize } from "~/helpers/style";

export const LimitsModalCloseButtonStyles = createGlobalStyle`
  .plan-limits-modal-wrapper .modal-close-button {
    top: 16px;
    right: 16px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ModalContent = styled.div`
  width: 100%;
  max-width: 536px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  box-sizing: border-box;
`;

export const TopSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
`;

export const BottomSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-sizing: border-box;
`;

export const IconContainer = styled.div`
  background-color: ${getColor("primaryLight")};
  width: ${getSize(4.8)};
  height: ${getSize(4.8)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: ${getSize(1.8)};
  line-height: ${getSize(2.8)};
`;

export const Description = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: ${getSize(1.4)};
  line-height: ${getSize(2.2)};
  width: 100%;
`;

export const TestimonialContainer = styled.div`
  background-color: ${getColor("background")};
  border-radius: ${getBorderRadius(1.2)};
  padding: ${getSize(0.6)} ${getSize(1.2)};
  display: flex;
  align-items: flex-start;
  gap: ${getSize(1.2)};
  width: 100%;
  box-sizing: border-box;
`;

export const TestimonialImage = styled.img`
  width: ${getSize(4.0)};
  height: ${getSize(4.0)};
  border-radius: 50%;
  background-color: ${getColor("textSecondary")};
  margin-top: ${getSize(0.2)};
`;

export const TestimonialText = styled.span`
  font-weight: 400;
  font-style: italic;
  font-size: ${getSize(1.3)};
  line-height: ${getSize(2.2)};
  flex: 1;
  min-width: 0;
`;

export const SwitchButton = styled(Button)`
  background-color: ${getColor("primary")};
  color: ${getColor("white")};
  margin: 0;
  width: 100%;
  font-weight: 600;
  font-size: ${getSize(1.6)};
  line-height: ${getSize(2.4)};
  padding: ${getSize(1.0)};
  box-sizing: border-box;
`;

export const DisclaimerText = styled.p`
  font-weight: 400;
  font-style: italic;
  font-size: ${getSize(1.3)};
  line-height: ${getSize(2.2)};
  color: ${getColor("textSecondary")};
  margin: 0;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
`;
